module.exports = __webpack_public_path__ + "h5/img/funv-bottom-goback.9a760eb0.png";